import Logger from "../../../utils/Logger";
const TAG = 'FrameCollectionDispatcher';
export default class FrameCollectionDispatcher {
    static dispatchMessage(targetWindow, type, payload) {
        Logger.debug(TAG, `Dispatching ${type} message to the frame...`);
        if (targetWindow) {
            targetWindow.postMessage({
                type: type,
                ...payload
            }, '*');
        }
    }
}
//# sourceMappingURL=FrameCollectionDispatcher.js.map